import { computed } from 'vue';
import { trackingState, setUserInfo, track, setUserProperties, clearUserInfo } from '@/config/tracking';

/**
 * 埋点相关的组合式函数
 * 专注于核心埋点功能
 */
export function useTracking() {
  /**
   * 发送埋点事件
   */
  const sendTrack = (eventName: string, properties?: Record<string, any>) => {
    return track(eventName, properties);
  };

  /**
   * 设置用户信息（支持用户ID或完整信息）
   */
  const setUser = (user_id: string | number) => {
    return setUserInfo(user_id);
  };

  /**
   * 设置用户属性
   */
  const setProperties = (properties: Record<string, any>) => {
    return setUserProperties(properties);
  };

  /**
   * 用户登出
   */
  const logout = () => {
    return clearUserInfo();
  };

  /**
   * 计算属性：是否已初始化
   */
  const isInitialized = computed(() => trackingState.isInitialized.value);

  /**
   * 计算属性：用户是否已登录
   */
  const isUserLoggedIn = computed(() => trackingState.isUserLoggedIn.value);

  /**
   * 计算属性：初始化错误
   */
  const initError = computed(() => trackingState.initError.value);

  return {
    // 核心功能
    track: sendTrack,
    setUser,
    setProperties,
    logout,
    
    // 状态
    isInitialized,
    isUserLoggedIn,
    initError,
  };
} 